<template>
	<div class="wrapper point">
		<div class="point-header">
			<div class="back-wrapper">
				<button @click="goBack" class="goback"><span class="visually-hidden">Go Back</span></button>
			</div>
			<div class="point-image">
				<img v-if="point.image != ''" :src="point.image" :alt="point.title+' '+this.t('txt_photo')">
			</div>
			<div v-if="point.done != 1 " class="point-instructions animate__animated animate__headShake">
				<div class="padding">
					<p v-if="checkIfExists('challenge')">{{ t('txt_take_picture_cta') }}</p>
					<p v-if="checkIfExists('location')">{{ t('txt_confirm_location_cta') }}</p>
					<p v-if="checkIfExists('qr')">{{ t('txt_scan_qr_cta') }}</p>
					<div class="actions">
						<div class="sparkholder">{{ point.sparks }}</div>
						<div v-if="checkIfExists('challenge')">
							<button @click="scrollTo" ref="scrollTo" class="scrollto"><span class="visually-hidden">{{  t('txt_challenge') }}</span></button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="point-done animate__animated animate__headShake">
				<div class="padding">
					<div class="sparkholder">{{ point.sparks }}</div>
					<div class="done"><img src="../assets/img/done-point.svg"></div>
				</div>
			</div>
		</div>
		<div class="content">
			<h2 v-html="point.title"></h2>
			<!-- <h3>{{ point.summary }}</h3> -->
			<div v-if="point.type == 'event'">
				<h3 v-if="isSameDate(point.event_date, point.event_date_end)">{{ formatDate(point.event_date) }}</h3>
				<h3 v-else>{{ formatDate(point.event_date, 'L') }} - {{ formatDate(point.event_date_end, 'L') }}</h3>
				<div v-html="point.event_location" class="event-location"></div>
			</div>
			<div v-html="point.description"></div>
			<div v-if="point.challange_description != '' && checkIfExists('challenge') && point.done != 1" class="challeng-content">
				<h2>{{  t('txt_challenge') }}</h2>
				<p>{{ point.challange_description }}</p>
			</div>
		</div>
		<div v-if="point.done != 1 && isTodayInEventRange(point.type, point.event_date, point.event_date_end)" class="action"  ref="scrollTarget">
			<button v-if="checkIfExists('qr')" @click="startScanning" ref="qrscan" class="green qr">{{ t('txt_scan_qr') }}</button>
			<div v-if="(checkIfExists('location') || checkIfExists('challenge')) && distance <= radius">
				<button v-if="checkIfExists('challenge')" @click="startCamera" ref="" class="green qr">{{ t('txt_take_picture') }}</button>
				<button v-if="checkIfExists('location')" @click="confirmLocation" ref="confirmLocationButton" class="green qr">{{ t('txt_confirm_location') }}</button>
			</div>
			<div v-else-if="checkIfExists('location')" class="disabled">
				<button class="green qr disabled" disabled="disabled">{{ t('txt_confirm_location') }}</button>
				<p>{{ t('txt_waiting_for_location', {'radius':radius}) }}</p>
			</div>
			<div v-else-if="checkIfExists('challenge')" class="disabled">
				<button class="green qr disabled" disabled="disabled">{{ t('txt_take_picture') }}</button>
				<p>{{ t('txt_waiting_for_location', {'radius':radius}) }}</p>
			</div>
		</div>
		<div v-else-if="point.type == 'event'" class="action"  ref="scrollTarget">
			<p>{{ t('txt_event_not_started') }}</p>
		</div>
		<div v-if="scanning" class="qr-code-wrapper">
			<div id="qr-reader" class="qr-reader full-screen"></div>
			<div class="button-wrap">
				<button @click="stopScanning" ref="qrscan" class="green">{{ t('txt_stop_scan_qr') }}</button>
			</div>
		</div>
		<CameraComponent ref="cameraComponent" :sparks="parseInt(point.sparks)" :id="id" />
	</div>
	<div v-if="state.show" class="fullscreen-popup">
		<button @click="closePopup" class="close"><span class="visually-hidden">Close</span></button>
		<div class="popup-content">
			<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" />
			<h1>{{ state.title }}</h1>
			<div v-html="state.description" class="description"></div>
			<div v-if="award" class="award-data">
				<div class="info">
					<h2>{{ award.title }}</h2>
					<div class="location">{{ t('txt_at') }} <router-link :to="`/providers/map/${award.partner_id}`" v-html="award.partner_title"></router-link></div>
				</div>
				<div class="until">{{ t('txt_until') }} {{ formatDate(award.valid_until, 'L') }}</div>
			</div>
			<div v-if="award" class="award-action">
				<div class="toprofile">
					<router-link :to="{ path: `/profile` }" class="">
						{{ t('txt_check_awards') }}
					</router-link>
				</div>
			</div>
		</div>
	</div>
	<div v-if="locationError" class="locationError">
		<p>{{ t('txt_location_not_allowed') }}</p>
	</div>
	<MobileNav :selected="selectedId" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import apiClient from '@/utils/axios';
import { Html5Qrcode } from "html5-qrcode";
import { nextTick } from 'vue';
import { ref } from 'vue';
import dayjs from '@/utils/dayjs';

export default {
	props: ['id'],
	name: 'AwardDetail',
	data() {
		return {
			point: {
				image: '',
				challenge: []
			},
			locationError: false,
			distance: 300,
			radius: 100,
			selectedId: 0,
			scanning: false,
			selectedAvatar: this.selectedAvatar,
			state: {
				show: false
			},
			award: false,
			avatars: [
				{ id: '1', image: require('../assets/img/eda-spomenik.svg'), name: 'fox' },
				{ id: '2', image: require('../assets/img/goriska-vrtnica.svg'), name: 'goriska-vrtnica' },
				{ id: '3', image: require('../assets/img/goriski-grad.svg'), name: 'goriski-grad' },
				{ id: '4', image: require('../assets/img/soca.svg'), name: 'soca' },
				{ id: '5', image: require('../assets/img/solkanski-most.svg'), name: 'solkanski-most' },
				{ id: '6', image: require('../assets/img/solkanski-radic.svg'), name: 'solkanski-radic' },
				{ id: '7', image: require('../assets/img/soska-postrv.svg'), name: 'postrv' },
				
			],
		};
	},
	computed: {
		fullName() {
			return `${keycloak.tokenParsed?.given_name || 'Name'} ${keycloak.tokenParsed?.family_name || 'Surname'}`;
		},
		avatarImage() {
			return this.getAvatarById(this.selectedAvatar)?.image || this.getAvatarById('1')?.image;
		},
		avatarName() {
			return this.getAvatarById(this.selectedAvatar)?.name || this.getAvatarById('1')?.name;
		}
	},
	methods: {
		isSameDate(date1, date2) {
			return (date1 == date2 || date2 == '') ? true : false;
		},
		isTodayInEventRange(type, event_date, event_date_end) {
			if(type != 'event'){
				return true;
			}

			const now = new Date();
			const startDate = new Date(event_date);

			if (!event_date_end) {
				return now >= startDate;
			} else {
				const endDate = new Date(event_date_end);
				return now >= startDate && now <= endDate;
			}
		},
		openPopup() {
			this.state.title = this.t('txt_point_done', {'sparks':this.point.sparks});
			this.state.description = '';
			this.state.show = true;
		},
		closePopup() {
			window.location.reload();
		},
		formatDate(date, format='L LT') {
			return dayjs(date).locale(localStorage.getItem('lang')).format(format);
		},
		checkIfExists(challengeType) {
			return this.point.challenge.includes(challengeType);
		},
		scrollTo() {
			this.$refs.scrollTarget.scrollIntoView({ behavior: 'smooth' });
		},
		getAvatarById(id) {
			return this.avatars.find(avatar => avatar.id === id);
		},
		calculateDistance(lat1, lon1, lat2, lon2) {
			const toRadians = (degrees) => degrees * (Math.PI / 180);

			const R = 6371000;
			const l1 = toRadians(lat1);
			const l2 = toRadians(lat2);
			const d1 = toRadians(lat2 - lat1);
			const d2 = toRadians(lon2 - lon1);

			const a =
				Math.sin(d1 / 2) * Math.sin(d1 / 2) +
				Math.cos(l1) * Math.cos(l2) * Math.sin(d2 / 2) * Math.sin(d2 / 2);

			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

			return R * c; 
		},
		async confirmLocation(){
			this.isAuthenticated = keycloak.authenticated;
			if (this.isAuthenticated) {
				try {
					const lang = localStorage.getItem('lang') || 'en';
					const data = this.currentPosition;
					this.$refs.confirmLocationButton.innerHTML = this.t('txt_working');
					this.$refs.confirmLocationButton.setAttribute('disabled',true);
					const response = await apiClient.post(`/${lang}/api/location/${this.id}`, data);
					if(response.data.award){
						this.award = response.data.award;
					}
					this.openPopup();
				} catch (error) {
					this.$refs.confirmLocationButton.innerHTML = this.t('txt_confirm_location');
					this.$refs.confirmLocationButton.setAttribute('disabled',false);
					console.error('Error fetching point:', error);
				}
			}
		},
		async fetchPoint() {
			this.isAuthenticated = keycloak.authenticated;
			if (this.isAuthenticated) {
				try {
					const lang = localStorage.getItem('lang') || 'en';
					const response = await apiClient.get(`/${lang}/api/point/${this.id}`);
					this.point = response.data;
					if(this.checkIfExists('location') || this.checkIfExists('challenge')){
						try {
							this.startPositionWatch();
						} catch (error) {
							console.error('Error in setCurrentLocation():', error);
						}
					}
				} catch (error) {
					console.error('Error fetching point:', error);
				}
			}
		},
		startScanning() {
			this.scanning = true;
			nextTick(() => {
				setTimeout(() => {
					this.initializeQrScanner();
				}, 100);
			});
		},
		stopScanning() {
			if (this.html5QrCode) {
				this.html5QrCode.stop().then(() => {
					this.scanning = false;
				}).catch(err => {
					console.error("Error stopping scanner:", err);
				});
			}
		},
		async confirmQr(qr){
			this.isAuthenticated = keycloak.authenticated;
			if (this.isAuthenticated) {
				try {
					const lang = localStorage.getItem('lang') || 'en';
					const data = { 'qr':qr };
					const response = await apiClient.post(`/${lang}/api/qr/${this.id}`, data);
					if(response.data.award){
						this.award = response.data.award;
					}
					this.openPopup();
				} catch (error) {
					console.error('Error fetching point:', error);
				}
			}
		},
		initializeQrScanner() {
			const qrCodeRegionId = "qr-reader";
			const element = document.getElementById(qrCodeRegionId);
			if (!element) {
				return;
			}
			this.html5QrCode = new Html5Qrcode(qrCodeRegionId);
			this.html5QrCode.start(
				{ facingMode: "environment" },
				{
					fps: 15,
					qrbox: { width: 250, height: 250 },
				},
				(decodedText) => {
					const scannerElement = document.getElementById(qrCodeRegionId);
					if (scannerElement) {
						scannerElement.style.border = "5px solid #29CCB1";
					}

					setTimeout(() => {
						if (this.html5QrCode.isScanning) {
							this.html5QrCode.stop().then(() => {
								this.scanning = false;
								this.confirmQr(decodedText);
							}).catch(console.error);
						} else {
							this.scanning = false;
							this.confirmQr(decodedText);
						}
					}, 1000);
				}
			).then(() => {
				setTimeout(() => {
					const video = document.querySelector('#qr-reader > video');
					if (video) {
						video.style.width = '100%';
						video.style.height = '100%';
						video.style.objectFit = 'cover';
					}
				}, 100);
			}).catch((err) => {
				console.error("Camera initialization failed:", err);
			});
		},
		startPositionWatch() {
			if (navigator.geolocation) {
				this.positionWatcher = navigator.geolocation.watchPosition(
				(position) => {
					this.locationError = false;
					this.currentPosition = {
						lat: position.coords.latitude,
						lon: position.coords.longitude,
					};
					this.distance = this.calculateDistance(this.currentPosition.lat, this.currentPosition.lon, this.point.lat, this.point.lon);
				},
				(error) => {
					this.locationError = true;
					this.handleGeolocationError(error);
				},
				{ enableHighAccuracy: true }
				);
			} else {
				this.locationError = true;
				console.error('Geolocation is not supported by this browser.');
			}
		},
		stopPositionWatch() {
			if (this.positionWatcher !== null) {
				navigator.geolocation.clearWatch(this.positionWatcher);
				this.positionWatcher = null;
			}
		},
		handleGeolocationError(error) {
			switch (error.code) {
				case error.PERMISSION_DENIED:
					this.locationError = true;
					break;
				case error.POSITION_UNAVAILABLE:
					this.retryLocationRequest();
					break;
				case error.TIMEOUT:
					this.retryLocationRequest();
					break;
				default:
					this.locationError = false;
					break;
			}
		},
		retryLocationRequest() {
			setTimeout(() => {
				this.startPositionWatch();
			}, 3000);
		},
		startCamera() {
			this.$refs.cameraComponent.startCamera();
		},
	},
	beforeUnmount() {
		this.stopPositionWatch();
	},
	setup() {
		const currentPosition = ref(null);
		const { t } = useI18n();
		return {
			t,
			currentPosition
		};
	},
	mounted() {
		this.fetchPoint();
	},
};
</script>

<style lang="sass" scoped>
	
</style>